import { render } from "./record-list.vue?vue&type=template&id=024aeafe&scoped=true"
import script from "./record-list.vue?vue&type=script&lang=js"
export * from "./record-list.vue?vue&type=script&lang=js"

import "./record-list.vue?vue&type=style&index=0&id=024aeafe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024aeafe"]])

export default __exports__